import DefaultLayout from "../../layout/DefaultLayout";
import BreadcrumbTwo from "../../components/Breadcrumbs/BreadcrumbTwo";
import SectionWrapper from "../../components/SectionWrapper/SectionWrapper";

import AgingReportForm
  from "../../modules/payable/aging/components/AgingReportForm";

const AgingReportPage = () => {
  return (
    <DefaultLayout>
      <BreadcrumbTwo />

      <SectionWrapper>
        <AgingReportForm />
      </SectionWrapper>
    </DefaultLayout>
  );
};

export default AgingReportPage;